import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { auth } from '../../../src/config/firebase';
import NavLogo from '../../assets/nav-logo.svg';
import { Loader } from '../minor-components/Loader';
import { axiosInstance } from '../../constants/axiosInstance';
import { useAlert } from 'react-alert';

export const Otp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const alert = useAlert();
  const [loading, setLoading] = useState(false);
  const [OTP, setOTP] = useState('');
  const [resendDisabled, setResendDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const phoneNumber = location.state.phoneNumber;



  
  useEffect(() => {
    setupRecaptcha();
    sendOTP();
  }, []);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    } else {
      setResendDisabled(false);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  // Add state validation
  useEffect(() => {
    if (!location.state?.phoneNumber) {
      alert.show("Invalid navigation. Please sign up first");
      navigate('/signup', { replace: true });
      return;
    }
  }, []);

  

  const setupRecaptcha = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
        'size': 'invisible',
        callback: () => {
          // reCAPTCHA solved
        }
      });
    }
  };

  const sendOTP = async () => {
    try {
      setLoading(true);
      const formatPhone = phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
      
      const confirmationResult = await signInWithPhoneNumber(
        auth, 
        formatPhone,
        window.recaptchaVerifier
      );
      window.confirmationResult = confirmationResult;
      
      // Set resend countdown
      setResendDisabled(true);
      setCountdown(60);
      alert.show('OTP sent successfully');
    } catch (error) {
      console.error('Error sending OTP:', error);
      alert.show(error.message || 'Error sending OTP. Please try again.');
      
      // Reset recaptcha on error
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
        setupRecaptcha();
      }
    } finally {
      setLoading(false);
    }
  };

  const verifyOTP = async () => {
    if (!OTP || OTP.length !== 6) {
      alert.show('Please enter a valid 6-digit OTP');
      return;
    }

    try {
      setLoading(true);
      const result = await window.confirmationResult.confirm(OTP);
      
      // If Firebase verification succeeds, update backend
      const response = await axiosInstance.patch('/api/v1/user/updatePhoneVerification', {
        phoneNumber
      }, {
        headers: {
          'Authorization': localStorage.getItem('token')
        }
      });

      if (response.data.success) {
        alert.show('Phone number verified successfully');
        navigate('/age-verification', { state: { id: location.state.id }});
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      alert.show('Invalid OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {!loading ? (
        <div className="h-[100vh] flex bg-emerald-50 items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="w-auto shadow-md rounded-md bg-white flex justify-center">
            <div className="h-auto p-12">
              <div className="max-w-md w-full space-y-8">
                <div className="w-96">
                  <img className="mx-auto h-12 w-auto" src={NavLogo} alt="Logo" />
                  <h2 className="mt-2 pb-7 text-center text-2xl font-normal text-gray-600">
                    Let's get Started
                  </h2>
                </div>
                <div id="recaptcha-container"></div>
                <form className="mt-8 space-y-6" onSubmit={(e) => e.preventDefault()}>
                  <div className="rounded-md shadow-sm -space-y-px">
                    <div>
                      <div className="mb-3 ml-4">
                        <label className="font-bold">
                          Enter the code sent to {phoneNumber}
                        </label>
                      </div>
                      <input
                        type="text"
                        value={OTP}
                        onChange={(e) => setOTP(e.target.value.replace(/\D/g, '').slice(0, 6))}
                        className="appearance-none rounded relative block w-96 px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-myBg-500 focus:border-myBg-500 focus:z-10 sm:text-sm"
                        placeholder="000000"
                      />
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      onClick={verifyOTP}
                      className="group relative w-96 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-black bg-myBg hover:bg-myBg-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-myBg-500"
                    >
                      Verify OTP
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      onClick={sendOTP}
                      disabled={resendDisabled}
                      className={`group relative w-96 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-black ${
                        resendDisabled ? 'bg-gray-200 cursor-not-allowed' : 'bg-white hover:bg-gray-100'
                      } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-myBg-500`}
                    >
                      {resendDisabled 
                        ? `Resend OTP in ${countdown}s` 
                        : 'Resend OTP'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};